<!-- 비회원 or 신청전 화면 -->
<template>
	<div class="section">
		<!-- 학습 신청 전 교육과정-->
		<strong class="tit">교육과정</strong>
		<div>
			<table class="tbl_rwd">
				<thead>
				<tr>
					<th>학습내용</th>
					<th>구분</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(content, i) in contentList">
					<td data-td="학습내용" class="left">
						<template v-if="content.contentType === 'mov'">
							<template v-if="content.qstMovVO != null">
								{{ content.qstMovVO.movTitle }}
							</template>
						</template>
						<template v-if="content.contentType === 'file'">
							{{ content.qstFileVO.fileDesc }}
						</template>
						<template v-if="content.contentType === 'tst'">
							테스트 {{ content.qstTstList.length }} 문항
						</template>
						<template v-if="content.contentType === 'wait'">
							준비중
						</template>
					</td>
					<td data-td="구분">
						<template v-if="content.contentType === 'mov'">동영상</template>
						<template v-if="content.contentType === 'file'">파일</template>
						<template v-if="content.contentType === 'tst'">테스트</template>
						<template v-if="content.contentType === 'wait'">미정</template>
					</td>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	name: "eduBefore",
	props: {
		contentList: Array,
	}
}
</script>

<style scoped>

</style>
